// Firebase configuration
import { initializeApp } from 'firebase/app';
// import { getAnalytics, isSupported } from 'firebase/analytics';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';

// Your web app's Firebase configuration
// Uses environment variables with fallback to existing values for backward compatibility
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || "AIzaSyA5svwvx8M6RezKYBibpEHO6a1M7ck-iws",
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || "fabiha-zaman.firebaseapp.com",
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || "fabiha-zaman",
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || "fabiha-zaman.firebasestorage.app",
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || "949326680930",
  appId: import.meta.env.VITE_FIREBASE_APP_ID || "1:949326680930:web:6de845b1d7c2fdc78cd23b",
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID || "G-TJFBJLH8MZ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);
const functions = getFunctions(app);

// Initialize Analytics (temporarily disabled to isolate 400 error)
let analytics = null;
/*
if (typeof window !== 'undefined') {
  import('firebase/analytics').then(({ getAnalytics, isSupported }) => {
    isSupported().then((supported) => {
      if (supported) {
        analytics = getAnalytics(app);
      }
    }).catch(console.warn);
  });
}
*/

export { app, analytics, db, auth, storage, functions };
